<template>
  <entity-edit-dialog
      @submit="submit"
      @close="close"
      v-model="visible"
      ref="editDialog"
      :dialog-title="dialogTitle"
      :submitting="submitting">
    <template v-slot:contentCard>
      <v-card-text class="pt-5">

        <service-order-view :defect-report-d-t-o="relatedDefectReportDTO"
                            :planned-service-d-t-o="relatedPlannedServiceDTO"
                            class="mb-5"/>

        <entity-dialog-input-row :label="$t('service.doneDate')" :required="true">
          <date-picker v-model="service.doneDate"
                       :rules="[buildRequiredValidator(),]"/>
        </entity-dialog-input-row>

        <entity-dialog-input-row :label="$t('service.description')" :required="true">
          <v-textarea
              v-model="service.description"
              rows="3"
              outlined
              hide-details="auto"
              :rules="[buildRequiredValidator(),]"/>
        </entity-dialog-input-row>

        <entity-dialog-input-row v-if="$featurePermissions.serviceInstalledPartsInput"
                                 :label="$t('service.installedParts')">
          <part-quantities-select v-model="service.installedParts"/>
        </entity-dialog-input-row>

        <entity-dialog-input-row :label="$t('service.documents')" divider-after>
          <documents-select v-model="documents"/>
        </entity-dialog-input-row>

        <entity-dialog-input-row :label="$t('service.doneByUsers')" :required="true">
          <div class="d-flex flex-column">
            <done-by-users-select v-model="service.doneByUsers"/>
            <div class="d-flex flex-row mt-3">
              <div class="mr-3">{{ $t('service.totalDuration') }}</div>
              <div><span v-if="totalDuration">{{ totalDuration | duration }}</span>
                <span v-else>...</span>
              </div>
            </div>
          </div>
        </entity-dialog-input-row>

        <entity-dialog-input-row :label="$t('service.expenses')" divider-after>
          <expenses-input v-model="service.expenses"/>
        </entity-dialog-input-row>


        <entity-dialog-input-row v-if="service.defectReport"
                                 :label="$t('service.defectReportStatus')"
                                 :required="true">
          <defect-report-status-select v-model="service.defectReport.status"
                                       :rules="[buildRequiredValidator(),]"/>
        </entity-dialog-input-row>

        <entity-dialog-input-row :label="$t('service.serviceState')">
          <div class="d-flex flex-column">
            <service-state-select v-model="service.serviceState"/>
            <v-checkbox v-model="service.cleanedCheckedAccepted"
                        :label="$t('service.cleanedCheckedAccepted')"
                        hide-details/>
          </div>
        </entity-dialog-input-row>
      </v-card-text>
    </template>
  </entity-edit-dialog>
</template>

<script>
import EntityDialogInputRow from '@/components/entity-crud/EntyDialogInputRow';
import i18n from '@/i18n';
import EntityEditDialog from '@/components/entity-crud/EntityEditDialog';
import DocumentsSelect from '@/components/inputs/DocumentsSelect';
import DefectReportStatusSelect from '@/components/inputs/DefectReportStatusSelect';
import { buildRequiredIfValidator, buildRequiredValidator, buildMaxLengthValidator } from '@/utils/ValidatorBuilders';
import DatePicker from '@/components/inputs/DatePicker';
import ServiceService from '@/services/ServiceService';
import PartQuantitiesSelect from '@/components/inputs/PartQuantitiesSelect';
import ServiceStateSelect from '@/components/inputs/ServiceStateSelect';
import DoneByUsersSelect from '@/views/service/DoneByUsersSelect';
import ExpensesInput from '@/views/service/ExpensesInput';
import ServiceOrderView from '@/views/service/ServiceOrderView';

export default {
  name: 'ServiceDialog',
  components: {
    ServiceOrderView,
    ExpensesInput,
    DoneByUsersSelect,
    ServiceStateSelect,
    DocumentsSelect,
    DefectReportStatusSelect,
    PartQuantitiesSelect,
    DatePicker,
//    DefectReportStatusSelect,
//    DocumentsSelect,
    EntityEditDialog,
//    PrioritySelect,
//    DeviceSelectField,
    EntityDialogInputRow,
  },
  data: () => ({
    sendNotificationMails: false,
    service: null,
    relatedDefectReportDTO: null,
    relatedPlannedServiceDTO: null,
    documents: [],
    visible: false,
    submitting: false,

  }),
  props: {},
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },

    dialogTitle() {
      if (this.service?.id) {
        return i18n.t('service.editDialog.titleEdit');
      } else {
        return i18n.t('service.editDialog.titleAdd');
      }
    },
    totalDuration() {
      if (!this.service) {
        return null;
      }

      const workMinutes = this.service.doneByUsers
          .map(doneByUser => doneByUser.workDuration)
          .filter(duration => duration !== null);

      if (workMinutes.length === 0) {
        return null;
      }

      return workMinutes.reduce((total, current) => total + current, 0);
    },
  },
  methods: {
    buildRequiredIfValidator,
    buildRequiredValidator,
    buildMaxLengthValidator,
    close() {
      this.visible = false;
      this.service = null;
      this.submitting = false;
      this.relatedPlannedServiceDTO = null;
      this.relatedDefectReportDTO = null;
    },

    openCreateServiceForDefectReport(defectReportId) {
      ServiceService.getPrefilledForDefectReport(defectReportId).then(result => {
        this.service = result.data.service;
        this.relatedDefectReportDTO = result.data.relatedDefectReportDTO;
        this.relatedPlannedServiceDTO = null;
        this.documents = [];
        this.visible = true;
      }).catch(err => {
        console.log(JSON.stringify(err));
      });
    },

    openCreateServiceForPlannedServiceInstance(plannedServiceInstanceId) {
      ServiceService.getPrefilledForPlannedServiceInstance(plannedServiceInstanceId).then(result => {
        this.service = result.data.service;
        this.relatedPlannedServiceDTO = result.data.relatedPlannedServiceDTO;
        this.relatedDefectReportDTO = null;
        this.documents = [];
        this.visible = true;
      }).catch(err => {
        console.log(JSON.stringify(err));
      });
    },


    openEditService(serviceId) {
      ServiceService.get(serviceId)
          .then(result => {
            this.service = result.data.service;
            this.relatedDefectReportDTO = result.data.relatedDefectReportDTO;
            this.relatedPlannedServiceDTO = result.data.relatedPlannedServiceDTO;
            this.documents = result.data.documents;
            this.visible = true;
          }).catch(err => {
        console.log(JSON.stringify(err));
      });
    },


    submit() {
      if (this.submitting) {
        return;
      }

      if (!this.$refs.editDialog.$refs.form.validate()) {
        this.$refs.editDialog.showFormHasValidationErrorsMessage(i18n.t('defectReport.requiredInformationMissing'));
        return;
      }

      this.service.durationMinutes = this.totalDuration;

      let serviceDTO = {
        service: this.service,
        documents: this.documents,
      };

      this.submitting = true;
      ServiceService.save(serviceDTO).then((result) => {
        this.$emit('done', result.data);
        this.close();
      }).catch(err => {
        console.log(JSON.stringify(err));
      }).finally(() => {
        this.submitting = false;
      });
    },
  },
};
</script>

<style scoped>
</style>
